export default __webpack_public_path__ + "adfba60e5bff57a40207fd674f2eebf7.png";